import Accounts from './Accounts'
import Budgets from './Budgets'
import CashFlow from './CashFlow'
import Debts from './Debts'
import General from './General'
import Goals from './Goals'
import Investments from './Investments'
import Mobile from './Mobile'
import NetWorth from './NetWorth'
import Notifications from './Notifications'
import RecurringTransactions from './RecurringTransactions'
import Spending from './Spending'
import Transactions from './Transactions'
import Trends from './Trends'
import Insights from './Insights'

const contentSection = {
  accounts: Accounts,
  alerts: Notifications,
  budgets: Budgets,
  cashflow: CashFlow,
  debts: Debts,
  general: General,
  goals: Goals,
  insights: Insights,
  investments: Investments,
  mobile: Mobile,
  networth: NetWorth,
  recurring_transactions: RecurringTransactions,
  spending: Spending,
  transactions: Transactions,
  trends: Trends,
}

export { contentSection }
